import { format, formatDistanceToNowStrict, parseISO, isValid } from "date-fns";

export const toDate = (v) => {
  if (!v) return null;
  const d = typeof v === "string" ? parseISO(v) : new Date(v);
  return isValid(d) ? d : null;
};
export const fmtDate = (v, f = "MMM d, yyyy") => {
  const d = toDate(v);
  return d ? format(d, f) : "—";
};
export const fmtDateTime = (v) => fmtDate(v, "MMM d, yyyy h:mm a");
export const fromNow = (v) => {
  const d = toDate(v);
  return d ? formatDistanceToNowStrict(d, { addSuffix: true }) : "—";
};
export const fmtDuration = (secs) => {
  if (secs == null || isNaN(secs)) return "0:00";
  const s = Math.max(0, Math.floor(secs));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return h ? `${h}:${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}` : `${m}:${String(r).padStart(2, "0")}`;
};
export const parseTimestamp = (str) => {
  const parts = String(str).trim().split(":").map(Number);
  if (parts.some(isNaN)) return null;
  return parts.reduce((acc, p) => acc * 60 + p, 0);
};

import { STATUS as STATUS_MAP } from "@/lib/statusConfig";
export { STATUS, STATUS_HEX, MIGRATION_BUCKET } from "@/lib/statusConfig";
export const statusLabel = (k) => STATUS_MAP[k]?.label || String(k ?? "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const ITEM_TYPE_LABEL = {
  video: "Video", interactive_video: "Interactive Video", pdf: "PDF", document: "Document", presentation: "Presentation", text: "Text Lesson", web_content: "Web Content",
  external_link: "External Link", acknowledgement: "Acknowledgement", quiz: "Quiz", assessment: "Quiz", survey: "Survey", policy_attestation: "Policy Attestation",
  scorm: "SCORM Package", xapi: "xAPI", instructor_led: "Instructor-Led", virtual_classroom: "Virtual Classroom", external_certification: "External Certification",
  migration_placeholder: "Migration Placeholder",
};
// Types that are not released yet, or are created only by the migration engine, are never offered in the builder.
export const AUTHORABLE_ITEM_TYPES = ["video", "interactive_video", "pdf", "document", "presentation", "text", "web_content", "external_link", "acknowledgement", "quiz", "survey", "policy_attestation", "scorm"];
// Learner-facing wording. Staff should never read system words like "elective" or "enrollment".
export const LEARNER_LABEL = { assigned: "Required", required: "Required", elective: "Optional", optional: "Optional", satisfied_by_equivalency: "Credit given" };
export const learnerLabel = (k) => LEARNER_LABEL[k] || statusLabel(k);
export const ROLE_LABEL = { super_admin: "Super Administrator", admin: "Administrator", contributor: "Contributor", branding: "Branding", manager: "Manager", learner: "Learner" };
export const pct = (v) => `${Math.round(v || 0)}%`;
